import { OptionType } from '@oai-frontend-monorepo/types';
import { TradierSymbolParser } from './tradier-symbol/TradierSymbolParser';

export function parseOptionTypeFromSymbol(input: string): 'call' | 'put' {
  const parsed = new TradierSymbolParser(input).parsed;

  if (!parsed) {
    throw new Error(`Could not parse option type from symbol: ${input}`);
  }

  return parsed.optionType === OptionType.CALL ? 'call' : 'put';
}

export default parseOptionTypeFromSymbol;
